// extracted by mini-css-extract-plugin
module.exports = {"block":"FormerAthletes_block__LO_zE","heading":"FormerAthletes_heading__9sigO","btnViewAll":"FormerAthletes_btnViewAll___Eh4b","list":"FormerAthletes_list__psK_0"};